module.exports = __webpack_public_path__ + "static/media/paragraph-rtl.cea3d320.svg";